import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/BarSorting2/editor/barsorting2editor.tsx",
    () => import("./barsorting2editor"),
);
